export default __webpack_public_path__ + "static/media/bendy-rectangle.f239b05a.png";